import React, { forwardRef } from 'react';

const RecipeTypeValidationsIcon = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z"
        fill="#CFE0C7"
      />
      <path
        d="M12.5123 13.23H10.8713C10.1062 13.23 9.37236 13.5339 8.83132 14.075C8.29028 14.616 7.98633 15.3498 7.98633 16.115C7.98633 16.8801 8.29028 17.6139 8.83132 18.155C9.37236 18.696 10.1062 19 10.8713 19H12.5123C13.2775 19 14.0113 18.696 14.5523 18.155C15.0934 17.6139 15.3973 16.8801 15.3973 16.115C15.3973 15.3498 15.0934 14.616 14.5523 14.075C14.0113 13.5339 13.2775 13.23 12.5123 13.23V13.23Z"
        fill="#A0E65C"
      />
      <path
        d="M15.3824 16.101C15.3814 15.3399 15.0785 14.6102 14.5403 14.0721C14.0022 13.5339 13.2725 13.231 12.5114 13.23H11.6914V19H12.5114C13.2753 18.9923 14.0054 18.6836 14.5429 18.1407C15.0805 17.5979 15.3822 16.8649 15.3824 16.101V16.101Z"
        fill="#79CC52"
      />
      <path
        d="M11.6914 5C11.3654 5.00053 11.0528 5.13029 10.8223 5.36084C10.5917 5.5914 10.462 5.90395 10.4614 6.23C10.4615 6.27611 10.4641 6.32219 10.4694 6.368L11.0044 11.179H12.3804L12.9154 6.364C12.9202 6.31916 12.9225 6.27409 12.9224 6.229C12.9216 5.90295 12.7916 5.5905 12.5609 5.36014C12.3301 5.12977 12.0175 5.00026 11.6914 5V5Z"
        fill="#FFBE40"
      />
      <path
        d="M12.9144 6.365C12.9331 6.19315 12.9154 6.0193 12.8624 5.85475C12.8095 5.69019 12.7225 5.53862 12.6072 5.40988C12.4918 5.28114 12.3507 5.17811 12.1929 5.10749C12.0351 5.03688 11.8643 5.00025 11.6914 5V11.18H12.3794L12.9144 6.365Z"
        fill="#FF9F40"
      />
      <path
        d="M13.2124 14.991C13.1743 14.9529 13.1291 14.9227 13.0793 14.9021C13.0296 14.8815 12.9762 14.8708 12.9224 14.8708C12.8685 14.8708 12.8152 14.8815 12.7654 14.9021C12.7157 14.9227 12.6704 14.9529 12.6324 14.991L11.6924 15.931L11.2824 16.341L10.7524 15.811C10.7143 15.773 10.6691 15.7427 10.6193 15.7221C10.5696 15.7015 10.5162 15.6909 10.4624 15.6909C10.4085 15.6909 10.3552 15.7015 10.3054 15.7221C10.2557 15.7427 10.2104 15.773 10.1724 15.811C10.1343 15.8491 10.1041 15.8943 10.0835 15.9441C10.0628 15.9939 10.0522 16.0472 10.0522 16.101C10.0522 16.1549 10.0628 16.2082 10.0835 16.258C10.1041 16.3077 10.1343 16.3529 10.1724 16.391L10.9924 17.211C11.0304 17.2491 11.0757 17.2793 11.1254 17.3C11.1752 17.3206 11.2285 17.3312 11.2824 17.3312C11.3362 17.3312 11.3896 17.3206 11.4393 17.3C11.4891 17.2793 11.5343 17.2491 11.5724 17.211L11.6924 17.091L13.2124 15.571C13.2505 15.5329 13.2807 15.4877 13.3013 15.438C13.3219 15.3882 13.3325 15.3349 13.3325 15.281C13.3325 15.2272 13.3219 15.1738 13.3013 15.1241C13.2807 15.0743 13.2505 15.0291 13.2124 14.991V14.991Z"
        fill="#F3F5F9"
      />
      <path
        d="M13.2124 14.991C13.1743 14.9529 13.1291 14.9227 13.0793 14.9021C13.0296 14.8815 12.9763 14.8708 12.9224 14.8708C12.8685 14.8708 12.8152 14.8815 12.7654 14.9021C12.7157 14.9227 12.6705 14.9529 12.6324 14.991L11.6924 15.931V17.091L13.2124 15.571C13.2505 15.5329 13.2807 15.4877 13.3013 15.438C13.322 15.3882 13.3326 15.3349 13.3326 15.281C13.3326 15.2272 13.322 15.1738 13.3013 15.1241C13.2807 15.0743 13.2505 15.0291 13.2124 14.991Z"
        fill="#D8E0F0"
      />
      <path
        d="M14.1525 9.94898H9.23049C8.90428 9.94898 8.59142 10.0786 8.36075 10.3092C8.13008 10.5399 8.00049 10.8528 8.00049 11.179V11.589L8.63049 11.999H14.8865L15.3865 11.589V11.179C15.3865 11.0171 15.3545 10.8568 15.2925 10.7074C15.2304 10.5579 15.1395 10.4221 15.0248 10.3078C14.9102 10.1936 14.7741 10.103 14.6244 10.0415C14.4747 9.97989 14.3144 9.94845 14.1525 9.94898Z"
        fill="#FFDF40"
      />
      <path
        d="M15.3824 11.59V11.1799C15.3824 10.8537 15.2528 10.5409 15.0222 10.3102C14.7915 10.0795 14.4786 9.94995 14.1524 9.94995H11.6914V12.0009H14.8864L15.3824 11.59Z"
        fill="#FFBE40"
      />
      <path
        d="M11.6915 11.59H8.00049V12C8.00049 12.1087 8.04369 12.213 8.12057 12.2899C8.19746 12.3668 8.30175 12.41 8.41049 12.41H14.9735C15.0822 12.41 15.1865 12.3668 15.2634 12.2899C15.3403 12.213 15.3835 12.1087 15.3835 12V11.59H11.6915Z"
        fill="#4D4D80"
      />
      <path
        d="M15.3824 12V11.59H11.6914V12.41H14.9724C15.0812 12.41 15.1854 12.3668 15.2623 12.2899C15.3392 12.213 15.3824 12.1087 15.3824 12V12Z"
        fill="#443D66"
      />
    </svg>
  );
});

export default RecipeTypeValidationsIcon;
